import React, {useEffect, useState} from "react";
import {Box, Button, Chip, Menu, OutlinedInput, Typography,} from "@mui/material";
import {ArrowDropDown} from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import TextInput from "../../../../../../components/TextInput";
import CustomCheckbox from "../../../../../../components/Checkbox";

const MarketDropdown = ({
    data,
    selectedMarkets,
    setSelectedMarkets,
    selectedType,
    setSelectedType,
    setPage
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [localList, setLocalList] = useState([]);
    const open = Boolean(anchorEl);

    // Initialize local list based on data
    useEffect(() => {
        if (data) {
            const initializedList = data.markets_list.map((item) => ({
                ...item,
                isSelected: selectedMarkets.some(
                    (selected) => selected.market_id === item.market_id
                ),
            }));
            setLocalList(initializedList);
        }
    }, [data, selectedMarkets]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <div className="form-grid-item bidding_multiplier_height">
                <Box
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        fontSize: "10px",
                        lineHeight: "100%",
                        color: "#373F41",
                    }}
                    pb={1}
                >
                    SELECT MARKETS
                </Box>
                <TextInput
                    placeholder={" Select a value "}
                    type="text"
                    readOnly
                    value={
                        selectedMarkets.length > 0
                            ? selectedMarkets.length === 1
                                ? selectedMarkets[0].name
                                : `${selectedMarkets.length} selected`
                            : ""
                    }
                    sx={{
                        backgroundColor: "white",
                        fontSize: "12px",
                        fontWeight: "400",
                        paddingLeft: "4px",
                        maxWidth: "300px",
                        minWidth: "300px",
                        minHeight: "28px",
                        maxHeight: "28px",
                    }}
                    endAdornment={<ArrowDropDown />}
                    onClick={handleClick}
                />
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={{ padding: 0 }}
                    PaperProps={{
                        sx: {
                            borderRadius: "10px",
                            maxWidth: "300px",
                            minWidth: "300px",
                        },
                    }}
                >
                    <Box sx={{ padding: "17px" }}>
                        <Typography
                            sx={{ fontSize: "10px", color: "#C4C4C4", marginBottom: "10px" }}
                        >
                            Select
                        </Typography>
                        <Box className="flex" sx={{ marginBottom: "10px" }}>
                            <Chip
                                label="Markets"
                                onClick={() => setSelectedType("markets")}
                                sx={{
                                    backgroundColor:
                                        selectedType === "markets" ? "#61D5A9" : "none",
                                    marginRight: "10px",
                                    height: "20px",
                                    width: "92px",
                                }}
                            />
                        </Box>
                        <OutlinedInput
                            sx={{
                                borderRadius: "10px",
                                borderColor: "#CADEDD",
                                width: "195px",
                                height: "28px",
                                fontSize: "12px",
                                marginBottom: '5px'
                            }}
                            size="small"
                            placeholder="Search"
                            value={searchTerm}
                            startAdornment={
                                <SearchIcon sx={{ color: "#CADEDD", fontSize: "18px" }} />
                            }
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <Box sx={{ marginTop: "5px" }}>
                            <CustomCheckbox
                                title="All Markets"
                                labelStyles={{ color: "#C4C4C4" }}
                                fontSize="10px"
                                size={"small"}
                                checked={localList.length > 0 && localList.every((item) => item.isSelected)}
                                onChange={() => {
                                    const allSelected = localList.every((item) => item.isSelected);
                                    setLocalList((prev) =>
                                        prev.map((item) => ({
                                            ...item,
                                            isSelected: !allSelected,
                                        }))
                                    );
                                }}
                            />
                            <ul
                                style={{
                                    listStyleType: "none",
                                    margin: 0,
                                    padding: 0,
                                    maxHeight: "250px",
                                    overflow: "auto",
                                }}
                            >
                                {localList
                                    .filter((item) =>
                                        item.name.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map((item) => (
                                        <li
                                            key={item.market_id}
                                            style={{
                                                padding: "7px",
                                                borderLeft: "1px solid #CADEDD",
                                            }}
                                        >
                                            <CustomCheckbox
                                                fontSize="12px"
                                                size={"small"}
                                                checked={item.isSelected}
                                                title={item.name}
                                                onChange={() => {
                                                    setLocalList((prev) =>
                                                        prev.map((i) =>
                                                            i.market_id === item.market_id
                                                                ? { ...i, isSelected: !i.isSelected }
                                                                : i
                                                        )
                                                    );
                                                }}
                                            />
                                        </li>
                                    ))}
                            </ul>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: "15px",
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{ color: "#C4C4C4", cursor: "pointer" }}
                                onClick={() => {
                                    setSelectedMarkets([]);
                                    setLocalList((prev) =>
                                        prev.map((item) => ({ ...item, isSelected: false }))
                                    );
                                    setSearchTerm("");
                                }}
                            >
                                Clear Filters
                            </Typography>
                            <Button
                                variant="outlined"
                                sx={{
                                    color: "black",
                                    backgroundColor: "#61D5A9",
                                    borderRadius: "20px",
                                    fontSize: "10px",
                                    width: "100px",
                                    height: "22px",
                                    paddingInline: "8px",
                                }}
                                onClick={() => {
                                    setSelectedMarkets(localList.filter((item) => item.isSelected));
                                    setPage(0);
                                    handleClose();
                                }}
                            >
                                Apply
                            </Button>
                        </Box>
                    </Box>
                </Menu>
            </div>
        </Box>
    );
};

export default MarketDropdown;
